module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/bookmark-blue-df44a21ef820dd5a0e4582418d5ccf78.svg";